import {InsideDrawerApplication} from "../inside-drawer.application";
import {IOpenAppData} from "@sparkware/uc-sdk-core";
import {ICasinofiedComponentFactory} from "../../casinofied-app-factory.interfaces";
import {CasinofiedAppSdkLoader} from "../../casinofied-app-sdk-loader";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {ICasinofiedApplicationAdapter} from "../adapters/casinofied-application-adapter.interface";
import {UnifiedCashierZoidAdapter} from "../adapters/unified-cashier-zoid-adapter";

export class DepositWidgetApplication extends InsideDrawerApplication {
    public constructor(openAppData: IOpenAppData,
                       componentFactory: ICasinofiedComponentFactory,
                       appSdkLoader: CasinofiedAppSdkLoader,
                       services: IServiceFactoryExtended) {
        super(openAppData, componentFactory, appSdkLoader, services, true);
    }


    get minOverlayZIndex(): number | null {
        return this.services.sdk.overlayZIndex.GAME_FRAME + 1;
    }

    get supportsCloseIntent(): boolean {
        return true;
    }

    dispose() {
        super.dispose();
        this.services.sdk.fireDepositWidgetClosed();
    }

    protected _createApplicationAdapter(appObject: any): ICasinofiedApplicationAdapter {
        return new UnifiedCashierZoidAdapter(this.appId, appObject);
    }
}